function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("circle", {
  id: "a",
  cx: 15,
  cy: 15,
  r: 15
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("mask", {
  id: "b",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("circle", {
  stroke: "#E4E4E4",
  strokeWidth: 2,
  cx: 15,
  cy: 15,
  r: 14
}), React.createElement("g", {
  mask: "url(#b)",
  fill: "#E4E4E4",
  fillRule: "nonzero"
}, React.createElement("g", {
  transform: "translate(8.000000, 9.000000)"
}, React.createElement("path", {
  d: "M14.2045455,20.7226107 C14.2045455,15.5537919 11.0247496,11.3636364 7.10227273,11.3636364 C3.17979581,11.3636364 1.6502355e-12,15.5537919 1.6502355e-12,20.7226107 C1.6502355e-12,20.7226107 3.08916785,22.4242424 7.05695875,22.4242424 C11.0247496,22.4242424 14.2045455,20.7226107 14.2045455,20.7226107 Z"
}), React.createElement("circle", {
  cx: 7.10227273,
  cy: 5.20833333,
  r: 5.20833333
}))))));

const SvgAvatarFallback = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgAvatarFallback, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/avatar-fallback.6e64bac5.svg";
export { ForwardRef as ReactComponent };